import React from 'react';

/* Crystal-and-gold emperor crown (jewel render). */
export const RoyalCrown = ({ size = 120, dim = false }) => (
  <img src="/oath/crown.png" alt="Crown" draggable={false} width={size} height={size} data-testid="royal-crown"
    style={{ width: size, height: size, objectFit: 'contain', filter: dim ? 'grayscale(1) opacity(0.35)' : 'drop-shadow(0 0 22px rgba(255,212,92,0.55))' }} />
);

export default RoyalCrown;
